// extracted by mini-css-extract-plugin
export var closeButton = "_2o-3";
export var header = "_2o-0";
export var link = "_2o-1";
export var retryButton = "_2o-2";